module.exports = __webpack_public_path__ + "img/logo.a49577de.png";